<nav class="nav nav-tabs" role="tablist">
  @for (tab of tabs(); track tab) {
    <button
      class="nav-link nav-link-tabs"
      [class.active]="tab === activeTab()"
      (click)="selectTab(tab)"
      type="button"
      role="tab"
    >
      {{ tab.label() }}
    </button>
  }
</nav>

@if (activeTab()?.template) {
  <ng-container [ngTemplateOutlet]="activeTab()?.template()"></ng-container>
}

@if (tabs().length > 0 && !activeTab()) {
  <div class="no-selection-message">
    @if (noSelectionTemplate()) {
      <ng-container [ngTemplateOutlet]="noSelectionTemplate()"></ng-container>
    } @else {
      {{ noSelection() }}
    }
  </div>
}

<ng-template #componentHost></ng-template>
